import {
    processFeatureFlagsAndABTest,
    FEATURE_FLAGS,
    FeatureFlags,
} from './utils';

export const getFlags = featureFlagsAbTests =>
    new FeatureFlags(
        processFeatureFlagsAndABTest({
            ...FEATURE_FLAGS,
            ...featureFlagsAbTests,
        }),
    );

export const getFeatureFlags = flags => ({
    brandNameIndex: flags.getValue('instantSearch.filters.brandNameIndex'),
    has3xPaymentIndex: flags.getValue(
        'instantSearch.filters.has_3xPaymentIndex',
    ),
    sellerNameIndex: flags.getValue('instantSearch.filters.sellerNameIndex'),
    priceIndex: flags.getValue('instantSearch.filters.priceIndex'),
    deliveryIndex: flags.getValue('instantSearch.filters.deliveryIndex'),
    showCategoriesFilterOnSearch: flags.getValue(
        'relevance.show.categories.filter.on.search',
    ),
});
